import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from '../services/api.service';

@Component({
    selector: 'app-approve-page',
    templateUrl: './approve-page.component.html',
    styleUrls: ['./approve-page.component.scss'],
    standalone: false
})
export class ApprovePageComponent implements OnInit, OnDestroy {
  responseData: any;
  loading: boolean = true;
  errorMessage: string | null = null;
  private subscriptions: Subscription = new Subscription(); 
  isLoading:boolean=false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
  ) {}

  ngOnInit() {

    const fullUrl = window.location.href;
    const referenceParam = fullUrl.includes('?') ? fullUrl.split('?')[1] : null;

    console.log("📌 Raw Reference Value:", referenceParam);

    if (referenceParam) {
      this.callApi(referenceParam);
    } else {
      this.setError("Invalid request parameters!");
    }
  }

  callApi(referenceParam: string) {
    
    this.isLoading=true;
    const apiSub = this.apiService.getApproveOrg(referenceParam).subscribe({
      
      next: (data) => {
        this.responseData = data?.errorDescription || "No error description available";
        this.loading = false;
        this.isLoading=false;
      },
      error: (error) => {this.setError(`Error fetching data: ${error.message}`);
        this.isLoading=false;}
    });

    this.subscriptions.add(apiSub);
  }

  setError(message: string) {
    this.errorMessage = message;
    this.loading = false;
  }

  goBack() {
    this.router.navigate(['/']);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
